import type { IControlState, ISectionState } from "@/types/ComponentLibrary/component-library";
import { defineStore } from "pinia";

export const sectionsStateStore = (identifier: string) =>
  defineStore(`section/${identifier}`, {
    state: () => ({
      state: {} as ISectionState,
      config: {},
      reload: true
    }),
  })(); // <- this is the key right here, by initialising it here

// export const controlStateStore = defineStore("controlState", {
//   state: () => ({
//      controls: new Map() as Map<string, IControlState>
// }),
//   actions: {
//     registerControlState(identifier:string,state : IControlState) {
//         this.controls.set(identifier,state);
//     },
//     patchControl(identifier:string,state:IControlState) {
//         this.controls.set(identifier,state);
//     }
//   },
// });
